import { Spacings } from '@styles'
import React from 'react'
import styled, { css } from 'styled-components'
import { Edit } from '@material-ui/icons'
import { EditIconWrapper, GSTCard, Value } from '@pages/Admin/OrgsAndUsers/Organisation/styles'
import { Label } from '../EditSupplierQuotes/styles'

export const AddressCardWrapper = styled(GSTCard)`
	margin-bottom: ${Spacings.SPACING_2B};
	border: 1px solid transparent;
	border-radius: ${Spacings.SPACING_2B};

	${({ hoverable }) => {
		if (hoverable) {
			return css`
				cursor: pointer;
				&:hover {
					border-color: ${({ theme }) => theme.palette.background.blue};
				}
			`
		}
	}}
`

const GSTAddressCard = ({ address, gst, onEditCallback, editable = false, hoverable = false }) => {
	return (
		<AddressCardWrapper hoverable={hoverable}>
			<div>
				<div>
					<Label>GST Number</Label>
					<Value>{gst ?? '--'}</Value>
				</div>
				{editable && (
					<div>
						<EditIconWrapper type='secondary' variant='' onClick={() => onEditCallback(address)}>
							<Edit fontSize='small' />
						</EditIconWrapper>
					</div>
				)}
			</div>
			{address && (
				<div>
					<Label>Billing Address</Label>
					<div>
						<Label margin={`${Spacings.SPACING_2B}`}>{`Address Id: ${address?.address_id ?? 'N/A'}`}</Label>
						<small>{address?.complete_address && <p>{address?.complete_address}</p>}</small>
						{
							<b>
								<small>
									{address?.city}, {address?.state} - {address?.pincode}{' '}
								</small>
							</b>
						}
					</div>
				</div>
			)}
		</AddressCardWrapper>
	)
}

export default GSTAddressCard
